import { Button } from '../components/ui/button';
import type { Go } from './types';

const VALUES = [
  {
    title: 'Specs deserve great software',
    body: 'Specification work has been stuck in clunky tools for decades. We think the people who write the documents that buildings are built from deserve something modern, fast, and genuinely pleasant to use.',
  },
  {
    title: 'Built with firms, not at them',
    body: 'SpecForma is shaped by real architecture and engineering workflows — masters, variants, issuances, addenda — not a generic document editor with specs bolted on.',
  },
  {
    title: 'Your standards stay yours',
    body: 'Per-firm isolation and clear ownership are foundational. Your masters, your formatting, your data — under your control.',
  },
];

export function AboutPage({ go }: { go: Go }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6">
      <h1 className="text-4xl font-bold tracking-tight text-text">
        We’re building the specification platform A/E firms actually want
      </h1>
      <p className="mt-6 text-lg leading-relaxed text-muted">
        SpecForma started from a simple frustration: writing and formatting construction
        specifications was harder than it needed to be. So we set out to build a project-management
        OS for specs — one that competes on user experience, AI, and formatting quality, not on
        feature bloat.
      </p>

      <div className="mt-14 flex flex-col gap-10">
        {VALUES.map((v) => (
          <div key={v.title}>
            <h2 className="text-2xl font-semibold text-text">{v.title}</h2>
            <p className="mt-2 text-md leading-relaxed text-muted">{v.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 rounded-2xl border border-border bg-bg-subtle p-8 text-center">
        <h2 className="text-2xl font-bold tracking-tight text-text">See it on your specs</h2>
        <p className="mx-auto mt-2 max-w-md text-md text-muted">
          The fastest way to understand SpecForma is to bring in the kind of sections your firm
          issues every week.
        </p>
        <div className="mt-6 flex justify-center">
          <Button size="lg" onClick={() => go('auth')}>
            Get started
          </Button>
        </div>
      </div>
    </div>
  );
}
